<template>
  <div id="wrapper">
    <Nav :message="message" />
    <FileFinder />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import FileFinder from '@/components/admin/FileFinder.vue'

export default {
  name: 'file-manager',
  props: ['message'],
  components: {
    Nav,
    FileFinder
  }
}
</script>